import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import uk from './locales/uk.json'

export const i18n = i18next.createInstance()

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      uk: { translation: uk },
    },
    // Preview default until we wire a proper language switcher.
    // English remains the fallback so missing keys still resolve.
    lng: 'uk',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  })
